import React, {Component} from "react";
import './baby-teething.css';
import * as TeethActions from './TeethingActions';
// import * as actions from '../Actions';

import Service from '../../service/Service';
const service = new Service();

export default function AddToothDetails({ChildTeethData, eleRef, thisTooth}) {
    // console.log(ChildTeethData.length);
    let addThDet;
    let tipsbreak;
    let tips;
    let tipTitle;
    for(let i=0; i<ChildTeethData.length; i++){
        if(thisTooth == ChildTeethData[i].toothId){
            var onlyDate = new Date(ChildTeethData[i].toothErruptionDate);
            var yr = onlyDate.getFullYear();
            var mn = onlyDate.getMonth() + 1;
            var dt = onlyDate.getDate();
            addThDet = yr + '/' + mn + '/' + dt;
			tipsbreak = ChildTeethData[i].toothTips.replace(/\n/g, "<br>");
            tips = tipsbreak.split('<br>');
            tipTitle = tips[0].replace("<b>", "").replace("</b>", "");
        }
    }

      
    var onlyDate = new Date();
    var maxDate = onlyDate.getDate() > 9 ? onlyDate.getDate() : "0" + onlyDate.getDate();
    var maxMonth= (onlyDate.getMonth() + 1) > 9 ? (onlyDate.getMonth() + 1) : "0" + (onlyDate.getMonth() + 1);
    var endDate = onlyDate.getFullYear() + '-' + maxMonth + '-' + maxDate;

   if(eleRef.state.selectedChlDOB){
        var date = eleRef.state.selectedChlDOB.split("-");
        var startDate = date[0] + '-' + date[1] + '-' + date[2] ;
    }
    
    return(
        <div>
        {ChildTeethData.map(teethInfo => 
            thisTooth == teethInfo.toothId ? 
            <div key={teethInfo.toothId} className="add-details">
                    <div className="M18_42 tooth-name">Tooth Name: <span className="tooth-nm">{teethInfo.toothName}</span>
                </div>
                <div className="M14_75 months">{teethInfo.startMonth} - {teethInfo.endMonth} Months</div>
                <div className="tooth-date">
                    <div className="M17_9e">Date</div>
                    <label htmlFor="teeth-date">
                        {   teethInfo.toothErruptionDate == '' ?
                            <input id="teeth-date" className="R12_42 date" type="text" defaultValue="" max={endDate} min={startDate} onKeyPress={(e) => service.onKeyPressDate(e)} onFocus={(e) => service.onFocusDate(e)} /> : 
                            <input id="teeth-date" className="R12_42 date" type="text" defaultValue={addThDet} max={endDate} min={startDate} onKeyPress={(e) => service.onKeyPressDate(e)} onFocus={(e) => service.onFocusDate(e)} />
                        }
                        <span data-icon-font="w" className="calender right"></span>
                    </label>
                </div>
                <div className="M16_42 enter-tet-det">Please enter tooth eruption details &nbsp;</div>
                <span className="R13_9e min-50">(minimum 250 characters)</span>
                <textarea placeholder="Write Here" maxLength="250" className="details-txt" defaultValue={teethInfo.toothErruptionDetails}></textarea>
                <div className="askB_1 save-btn" onClick={(e) => TeethActions.saveTeethData(eleRef)}>
                    <span className="M14_white devsave">SAVE</span>
                </div>
                <span id="star-five"></span>
                <div className="teeth-tips M16_42">Tips</div>
                <div className="R14_75 toothTips cropTip"><b>{tipTitle}</b><br/>{tips[1]}</div>
                <span className="read-more R14_link" onClick={() => TeethActions.readmore(eleRef)}>{eleRef.state.isreadmore ? "Read less" : "Read more"}</span>
                {/* <span className="read-less R14_link">Read less</span> */}
            </div> : null
        )}
        </div>
    )
}



// WEBPACK FOOTER //
// src/shared/tools/baby-teething/AddToothDetails.js